export const appName = "ZM Servis Moravia";
